"use client";

import type { ReactNode } from "react";

// Digits are split into separate constants so the full number never appears as
// a single contiguous string in the served HTML or JS payload, and the number
// is only assembled (and the chat opened) after a user clicks.
const WA_COUNTRY = "1";
const WA_PART_1 = "416";
const WA_PART_2 = "273";
const WA_PART_3 = "9031";

export function WhatsAppLink({
  className,
  label,
  children,
}: {
  className: string;
  label: string;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={() => {
        const url = `https://wa.me/${WA_COUNTRY}${WA_PART_1}${WA_PART_2}${WA_PART_3}`;
        window.open(url, "_blank", "noopener,noreferrer");
      }}
      aria-label={label}
      className={className}
    >
      {children}
    </button>
  );
}
